/* eslint-disable no-param-reassign */
import {fromJS} from "immutable";
import {DEFAULT_ACTION} from "containers/newTreatment/NewTreatmentUserStep/constants";
import {DATE_FORMATS} from "utils/Date";
import moment from "moment";
import {
  CREATE_DENTIST_ACTION,
  CREATE_DENTIST_FAILED_ACTION,
  CREATE_DENTIST_SUCCESS_ACTION,
  CREATE_PATIENT_ACTION,
  CREATE_PATIENT_FAILED_ACTION,
  CREATE_PATIENT_SUCCESS_ACTION,
  DELETE_DENTIST_ACTION,
  DELETE_DENTIST_FAILED_ACTION,
  DELETE_DENTIST_SUCCESS_ACTION,
  FILTER_DENTIST,
  FILTER_DENTIST_FAILED,
  FILTER_DENTIST_SUCCESS,
  FILTER_PATIENTS_ACTION,
  FILTER_PATIENTS_FAILED_ACTION,
  FILTER_PATIENTS_SUCCESS_ACTION,
  GET_ACTIVE_START_DATE,
  GET_DENTISTS_ACTION,
  GET_DENTISTS_FAILED_ACTION,
  GET_DENTISTS_SUCCESS_ACTION,
  GET_END_PRODUCTS,
  GET_END_PRODUCTS_FAILED,
  GET_END_PRODUCTS_SUCCESS,
  GET_INSURERS_ACTION,
  GET_INSURERS_FAILED_ACTION,
  GET_INSURERS_SUCCESS_ACTION,
  GET_PLANNED_TIMESLOTS,
  GET_PLANNED_TIMESLOTS_FAILED,
  GET_PLANNED_TIMESLOTS_SUCCESS,
  GET_PRACTICE_MESSAGES,
  GET_PRACTICE_MESSAGES_ERROR,
  GET_PRACTICE_MESSAGES_SUCCESS,
  GET_PRACTICE_PRODUCT_ORDERS_SUCCESS,
  GET_PRODUCT_ORDERS_ACTION,
  GET_PRODUCT_ORDERS_FAILED_ACTION,
  GET_PRODUCT_ORDERS_SUCCESS_ACTION,
  GET_TREATMENTS_ACTION,
  GET_TREATMENTS_FAILED_ACTION,
  GET_TREATMENTS_SUCCESS_ACTION,
  PURGE_DELETED_TIME_SLOTS,
  REMOVE_TIME_SLOT,
  RESET_DELETE_MESSAGE,
  RESET_DENTISTS,
  RESET_PATIENTS,
  SET_DATE,
  SET_SINGLE_PRACTICE,
} from "./constants";
import {DELETE_DENTIST, DELETE_DENTIST_FAILED, DELETE_DENTIST_SUCCESS,} from "../DentistDataPage/constants";

export const initialState = fromJS({
  patient: null,
  filteredPatients: [],
  filteredPatientsLoading: false,

  filteredDentists: [],
  filteredDentistsLoading: false,

  plannedTimeSlots: [],
  plannedTimeSlotsLoading: false,

  endProductTypes: {
    endProductTypes: [],
    endProductTypeConfigurations: [],
  },
  endProductsLoading: false,

  singlePractice: false,

  patientStepInProgress: false,
  dentistStepInProgress: false,

  // Treatments for the bookDay calendar.
  treatments: [],
  treatmentsLoading: false,

  productOrders: [],
  productOrdersLoading: false,

  dentist: null,
  deleted: false,
  deleteDentistLoading: false,
  dentistFailedMessage: null,

  dentists: [],
  dentistsLoading: false,

  insurers: [],
  insurersLoading: false,

  messages: [],
  messagesLoading: false,
  statusOpenCount: 0,

  practiceOrders: [],

  activeStartDate: new Date(),
  currentMonth: moment(),
});

function timeSortMethod(a, b) {
  return (a.eta.unix() - b.eta.unix()) * -1;
}

const handleDate = items =>
  items
    .map(item => {
      if (item.createdAtAtString) {
        item.createdAtAtString = moment(
          item.createdAtAtString,
          DATE_FORMATS.UTC,
        ).format(DATE_FORMATS.HUMAN_READABLE_DATE);
      }
      if (item.planned_date_time_from) {
        item.eta = moment(item.planned_date_time_from);

        item.planned_date_time_from = moment(
          item.planned_date_time_from,
          DATE_FORMATS.BUMBAL,
        ).format(DATE_FORMATS.HUMAN_READABLE_DATE);
      }

      return item;
    })
    .sort(timeSortMethod);

function appReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PRACTICE_PRODUCT_ORDERS_SUCCESS:
      return state.set("productOrders", fromJS(action.data));

    /**
     * Filter patients
     */
    case FILTER_PATIENTS_ACTION:
      return state.set("filteredPatientsLoading", true).set("filteredPatients", fromJS([]));;
    case FILTER_PATIENTS_FAILED_ACTION:
      return state
        .set("filteredPatientsLoading", false)
        .set("filteredPatients", fromJS([]));
    case FILTER_PATIENTS_SUCCESS_ACTION:
      return state
        .set("filteredPatientsLoading", false)
        .set("filteredPatients", fromJS(action.result));

    case RESET_PATIENTS:
      return state.set("filteredPatients", fromJS([]));

    /**
     * Filter dentist this has to be moved to Dentist Overview Page
     */
    case FILTER_DENTIST:
      return state.set("filteredDentistsLoading", true);
    case FILTER_DENTIST_FAILED:
      return state
        .set("filteredDentistsLoading", false)
        .set("filteredDentists", fromJS([]));
    case FILTER_DENTIST_SUCCESS:
      return state
        .set("filteredDentistsLoading", false)
        .set("filteredDentists", fromJS(action.result));

    case RESET_DENTISTS:
      return state.set("filteredDentists", fromJS([]));
    /**
     * Get end product types
     */
    case GET_END_PRODUCTS:
      return state.set("endProductsLoading", true);
    case GET_END_PRODUCTS_FAILED:
      return state.set("endProductsLoading", false);
    case GET_END_PRODUCTS_SUCCESS:
      return state
        .set("endProductsLoading", false)
        .set("endProductTypes", fromJS(action.result));
    /**
     * Get planned timeslots
     */
    case GET_PLANNED_TIMESLOTS:
      return state.set("plannedTimeSlotsLoading", true).set("plannedTimeSlots", fromJS([]));
    case GET_PLANNED_TIMESLOTS_FAILED:
      return state.set("plannedTimeSlotsLoading", false).set("plannedTimeSlots", fromJS([]));;
    case GET_PLANNED_TIMESLOTS_SUCCESS:
      return state
        .set("plannedTimeSlotsLoading", false)
        .set("plannedTimeSlots", fromJS(action.result));
    case REMOVE_TIME_SLOT: {
      const timeSlots = state.get("plannedTimeSlots").toJS();
      const index = timeSlots.findIndex(
        timeSlot => timeSlot.id === action.timeSlot.id,
      );
      if (index === -1) {
        return state;
      }
      // Set it to null instead of fully removing it, so the index it was on
      // is still valid.
      timeSlots[index].deleted = true;
      return state.set("plannedTimeSlots", fromJS(timeSlots));
    }
    /**
     * Create patient
     */
    case CREATE_PATIENT_ACTION:
      return state.set("patientStepInProgress", true);
    case CREATE_PATIENT_SUCCESS_ACTION:
      return state.set("patientStepInProgress", false);
    case CREATE_PATIENT_FAILED_ACTION:
      return state.set("patientStepInProgress", false);

    /**
     * Create dentist
     */
    case CREATE_DENTIST_ACTION:
      return state.set("dentistStepInProgress", true);
    case CREATE_DENTIST_SUCCESS_ACTION: {
      const dentists = state.get("dentists").toJS();
      dentists.push(action.result);

      return state
        .set("dentistStepInProgress", false)
        .set("dentists", fromJS(dentists));
    }
    case CREATE_DENTIST_FAILED_ACTION:
      return state.set("dentistStepInProgress", false);
    /**
     * Delete Dentist
     */
    case RESET_DELETE_MESSAGE:
      return state.set("dentistFailedMessage", null).set("deleted", false);

    case DELETE_DENTIST:
    case DELETE_DENTIST_ACTION:
      return state
        .set("deleteDentistLoading", true)
        .set("dentistFailedMessage", null);

    case DELETE_DENTIST_FAILED:
    case DELETE_DENTIST_FAILED_ACTION:
      return state
        .set("deleteDentistLoading", false)
        .set("dentistFailedMessage", action.reason)
        .set("deleted", false);

    case DELETE_DENTIST_SUCCESS:
    case DELETE_DENTIST_SUCCESS_ACTION: {
      return state
        .set("dentistFailedMessage", null)
        .set("dentist", null)
        .set("deleted", true)
        .set("deleteDentistLoading", false);
    }
    /**
     * Treatments for bookDay Calendar
     */
    case GET_TREATMENTS_ACTION:
      return state.set("treatmentsLoading", true);
    case GET_TREATMENTS_FAILED_ACTION:
      return state
        .set("treatmentsLoading", false)
        .set("treatments", fromJS([]));
    case GET_TREATMENTS_SUCCESS_ACTION:
      return state
        .set("treatmentsLoading", false)
        .set("treatments", fromJS(action.result));

    case GET_PRODUCT_ORDERS_ACTION:
      return state
        .set("productOrdersLoading", true)
        .set("productOrders", fromJS([]));
    case GET_PRODUCT_ORDERS_FAILED_ACTION:
      return state
        .set("productOrdersLoading", false)
        .set("productOrders", fromJS([]));
    case GET_PRODUCT_ORDERS_SUCCESS_ACTION:
      return state
        .set("productOrdersLoading", false)
        .set("productOrders", fromJS(action.result));

    case GET_DENTISTS_ACTION:
      return state.set("dentistsLoading", true).set("dentists",fromJS([]));
    case GET_DENTISTS_FAILED_ACTION:
      return state.set("dentistsLoading", false).set("dentists",fromJS([]));
    case GET_DENTISTS_SUCCESS_ACTION:
      return state.set("dentistsLoading", false).set(
        "dentists",
        fromJS(
          action.result.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          }),
        ),
      );

    case GET_INSURERS_ACTION:
      return state.set("insurersLoading", true).set("insurers",fromJS([]));
    case GET_INSURERS_FAILED_ACTION:
      return state.set("insurersLoading", false).set("insurers",fromJS([]));;
    case GET_INSURERS_SUCCESS_ACTION:
      return state
        .set("loading", false)
        .set("insurersLoading", false)
        .set(
          "insurers",
          fromJS(
            action.result.sort((a, b) => {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              return 0;
            }),
          ),
        );
    // Messages
    case GET_PRACTICE_MESSAGES:
      return state.set("messagesLoading", true).set("messages", fromJS([]));
    case GET_PRACTICE_MESSAGES_ERROR:
      return state.set("messagesLoading", false).set("messages", fromJS([]));
    case GET_PRACTICE_MESSAGES_SUCCESS:
      return state
        .set("messages", fromJS(action.messages))
        .set("statusOpenCount", action.statusOpenCount)
        .set("messagesLoading", false);

    case GET_ACTIVE_START_DATE:
      return state.set("activeStartDate", action.activeStartDate);

    case SET_DATE:
      return state.set("currentMonth", action.date);

    // case NEXT_MONTH: {
    //   const currentMonth = state.get("currentMonth");
    //   const max = getMaxDate();
    //   // Limit how far we can go forwards.
    //   if (currentMonth.isSameOrAfter(max, "M")) {
    //     return state;
    //   }
    //
    //   currentMonth.add(1, "M");
    //   return state.set("currentMonth", currentMonth);
    // }
    //
    // case PREVIOUS_MONTH: {
    //   const currentMonth = state.get("currentMonth");
    //
    //   if (currentMonth.isSameOrBefore(moment(), "M")) {
    //     return state;
    //   }
    //
    //   currentMonth.subtract(1, "M");
    //
    //   return state.set("currentMonth", currentMonth);
    // }

    /**
     * Other
     */

    case PURGE_DELETED_TIME_SLOTS: {
      const timeSlots = state.get("plannedTimeSlots").toJS();
      return state.set(
        "plannedTimeSlots",
        fromJS(timeSlots.filter(t => !t.deleted)),
      );
    }

    case SET_SINGLE_PRACTICE:
      return state
        .set("singlePractice", action.value)
        .set("activeStartDate", new Date())
        .set("currentMonth", moment().endOf("M"));
    case DEFAULT_ACTION:
    default:
      return state;
  }
}

export default appReducer;
